import Identity from "../";

const routes = [
    { name: "IdentityTest", path: "/identitytest", component: Identity.IdentityTestPage, meta: { title: "Identity Test" } },
    { name: "Identity User Info", path: "/identityuserinfo", component: Identity.IdentityUserInfoPage, meta: { title: "Identity User Info" } },
    { name: "IdentityManagerList", path: "/identitymanager", component: Identity.IdetityManagerListPage, meta: { title: "IdentityManagerList" } },
];
export default routes;
